import React from 'react';
import { BrowserRouter, Routes, Route} from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Article from './components/Article';
import Resume from './components/Resume';
import normalAndPoissonData from './data/normalAndPoisson.json';
import financialCalculatorData from './data/financialCalculator.json';
import frequencyAnalysisData from './data/frequencyAnalysis.json'


function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
      </div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/resume" element={<Resume />} /> 
        <Route path="/articles/NormalvPoisson" element={<Article data={normalAndPoissonData} />} />
        <Route path="/articles/FinancialCalculator" element={<Article data={financialCalculatorData} />} />
        <Route path="/articles/FrequencyAnalysis" element={<Article data={frequencyAnalysisData} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
